
import { employee, routes } from "./svg";

export const menuItems = [
  { title: "Dashboard", path: "/dashboard", icon: "dashboard.svg" },
  { title: "Client", path: "/client", icon: "client.svg" },
  { title: "vendor", path: "/vendor", icon: "vendor.svg" },
  { title: "Booking", path: "/booking", icon: "booking.svg" },
  { title: "Trips", path: "/trip", icon: "trips.svg" },
  { title: "Routes", path: "/routes", icon: routes },
  { title: "Vehicles", path: "/vehicles", icon: "vehicles.svg" },
  { title: "Driver", path: "/driver", icon: "driver.svg" },
  { title: "Employee", path: "/employee", icon: employee },
  { title: "Surveyor", path: "/Surveyor", icon: employee },
];